
import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import LazyImg from './LazyImg'

const useStyles = makeStyles((theme) => ({
    headerImgContainer: {
        '& div': {
            overflow: 'hidden',
            borderRadius: 5,
            [theme.breakpoints.down('sm')]: {
                paddingBottom: '50%'
            },
            [theme.breakpoints.only('sm')]: {
                paddingBottom: '40%'
            },
            [theme.breakpoints.up('md')]: {
                paddingBottom: '25%'
            }
        },
        '& img': {
            objectFit: 'cover',
            width: '100%',
            height: '100%'
            
        }
    }
}))

export default function HeaderImg({ph, srcMobile, srcDesktop}) {
    const classes = useStyles();

    return(
        <div className={classes.headerImgContainer}>
            <LazyImg placeholder={ph} srcSet={`${srcMobile} 750w, ${srcDesktop} 1024w`} alt=""/>
        </div>
    )
}